import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export type LeaveEventCreatorDialogProps = {
  open: boolean;
  onClose: () => void;
  onStay: () => void;
  onLeaveKeepDraft: () => void;
  onDiscardAndLeave: () => void;
  leaveBusy?: boolean;
};

export default function LeaveEventCreatorDialog({
  open,
  onClose,
  onStay,
  onLeaveKeepDraft,
  onDiscardAndLeave,
  leaveBusy = false,
}: LeaveEventCreatorDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Leave Event Creator?</DialogTitle>
      <DialogContent>
        Your inputs are automatically saved. You can continue anytime from My Workspace.
        If you prefer to start fresh, you can discard the saved creator draft now.
      </DialogContent>
      <DialogActions>
        <Button onClick={onStay} disabled={leaveBusy}>
          Stay here
        </Button>
        <Button onClick={onLeaveKeepDraft} disabled={leaveBusy}>
          Leave and keep draft
        </Button>
        <Button color="error" onClick={onDiscardAndLeave} disabled={leaveBusy}>
          Discard draft and leave
        </Button>
      </DialogActions>
    </Dialog>
  );
}
